import { TFunction } from 'i18next';

export type ProjectInvoiceStatusConfig = {
  code: string;
  getLabel: (t: TFunction) => string;
  color: string;
  routeId: string;

  valueCountsAsTaken: boolean;
  canCancel: boolean;
  canRequestDiscount: boolean;
  canChangePaymentMethod: boolean;
};

export const projectInvoiceStatusConfig = {
  paid: {
    code: '0',
    getLabel: (t: TFunction) => t('paid'),
    color: '#00D39D',
    routeId: 'paid',

    valueCountsAsTaken: true,
    canRequestDiscount: false,
    canCancel: false,
  },

  invoiced: {
    code: '1',
    getLabel: (t: TFunction) => t('invoiced'),
    routeId: 'invoiced',
    color: '#FC8A05',

    valueCountsAsTaken: true,
    canRequestDiscount: false,
    canCancel: false,
  },

  readyToInvoice: {
    code: '2',
    getLabel: (t: TFunction) => t('ready-to-invoice'),
    routeId: 'ready-to-invoice',
    color: '#03fc9d',

    valueCountsAsTaken: true,
    canRequestDiscount: true,
    canCancel: true,
  },

  discountRequested: {
    code: '3',
    getLabel: (t: TFunction) => t('discount-requested'),
    color: '#0352fc',
    routeId: 'discount-requested',

    valueCountsAsTaken: true,
    canRequestDiscount: false,
    canCancel: false,
  },

  readyToSendToAccountant: {
    code: '4',
    getLabel: (t: TFunction) => t('ready-to-send-to-accountant'),
    routeId: 'ready-to-send-to-accountant',
    color: '#3503fc',

    valueCountsAsTaken: true,
    canRequestDiscount: false,
    canCancel: false,
  },

  sentToAccountant: {
    code: '5',
    getLabel: (t: TFunction) => t('sent-to-accountant'),
    routeId: 'sent-to-accountant',
    color: '#dce703',

    valueCountsAsTaken: true,
    canRequestDiscount: false,
    canCancel: false,
  },

  canceled: {
    code: '9',
    getLabel: (t: TFunction) => t('canceled'),
    routeId: 'canceled',
    color: '#F3003A',

    valueCountsAsTaken: false,
    canRequestDiscount: false,
    canCancel: false,
  },
};

export const projectInvoiceConfigByCode = Object.fromEntries(
  Object.values(projectInvoiceStatusConfig).map((config) => [config.code, config]),
) as Record<string, ProjectInvoiceStatusConfig>;
